import { useEffect, useState } from "react";
import { fetchWithRetry, safeReadBody } from "@/lib/fetchWithRetry";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Public hook for the "Our Heritage" homepage Polaroid wall.
// Returns { items, loading, error } — `items` is an array of:
//   { id, image, caption: {en, fr, es}, rotation }
//
// Falls back to whatever the backend serves (defaults until an admin edits).
export const useHeritagePolaroids = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await fetchWithRetry(`${API}/heritage/polaroids`, { method: "GET" });
        if (!res.ok) {
          const txt = await safeReadBody(res);
          throw new Error(txt || `HTTP ${res.status}`);
        }
        const body = await res.json();
        if (active) {
          setItems(Array.isArray(body?.items) ? body.items : []);
          setLoading(false);
        }
      } catch (e) {
        if (active) {
          setError(e);
          setLoading(false);
        }
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return { items, loading, error };
};
